(() => {
  const id = "xencms:paragraph--tabs";

  Drupal.behaviors[id] = { attach: context => {
    once(id, ".paragraph--tabs", context).forEach(paragraph => {
      const mediaEl = paragraph.querySelector(".paragraph__media");
      if (!(mediaEl instanceof Element)) return;

      const itemsEl = paragraph.querySelector(".field--tabs-items");
      if (!(itemsEl instanceof Element)) return;

      const prevEl = paragraph.querySelector(".paragraph__arrow--prev");
      const nextEl = paragraph.querySelector(".paragraph__arrow--next");

      // Initialize data structures
      const items = [...itemsEl.children].map(item => {
        const media = item.querySelector(".field--tabs-item-media");
        return { item, media };
      });
      const state = {
        activeIndex: 0,
      };

      // Set active index
      const setActive = activeIndex => {
        state.activeIndex = Math.min(Math.max(activeIndex, 0), items.length - 1);
        items.forEach((item, index) => {
          if (index === state.activeIndex) {
            Object.values(item).forEach(el => el?.classList.add("is-active"));
            item.media?.querySelector("video")?.play();
          } else {
            Object.values(item).forEach(el => el?.classList.remove("is-active"));
            item.media?.querySelector("video")?.pause();
          }
        });
        prevEl?.classList.toggle("is-disabled", state.activeIndex < 1);
        nextEl?.classList.toggle("is-disabled", state.activeIndex >= items.length - 1);
      };

      // Initialize items
      items.forEach((item, index) => {
        if (item.item.classList.contains("is-active")) setActive(index);
        item.item.addEventListener("click", () => setActive(index));
        if (item.media) mediaEl.append(item.media);
      });

      // Initialize arrows
      prevEl?.addEventListener("click", () => setActive(state.activeIndex - 1));
      nextEl?.addEventListener("click", () => setActive(state.activeIndex + 1));
    });
  }};
})();
